import React from 'react';
import { LEGAL_LINKS } from '@/lib/legalLinks';


const A: React.FC<{ href: string; children: React.ReactNode }> = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-foreground">
    {children}
  </a>
);

/** "Terms of Service · Privacy Policy · Refund Policy" — inline, inherits the parent's text style. */
export const LegalLinks: React.FC<{ className?: string; includeRefunds?: boolean }> = ({ className, includeRefunds = true }) => (
  <span className={className} data-testid="legal-links">
    <A href={LEGAL_LINKS.terms}>Terms of Service</A>
    {' · '}
    <A href={LEGAL_LINKS.privacy}>Privacy Policy</A>
    {includeRefunds && (<>{' · '}<A href={LEGAL_LINKS.refunds}>Refund Policy</A></>)}
  </span>
);

/** The consent line shown where an account or organization is created. */
export const LegalConsentNotice: React.FC<{ action: string; className?: string }> = ({ action, className }) => (
  <p className={className ?? 'text-xs text-muted-foreground'} data-testid="legal-consent">
    By {action} you agree to GizmoData&apos;s <A href={LEGAL_LINKS.terms}>Terms of Service</A> and{' '}
    <A href={LEGAL_LINKS.privacy}>Privacy Policy</A>.
  </p>
);
